<template>
  <div class="list-item-content">
    <img class="list-item-content-icon"
         :src="app.icon_url" />

    <div class="list-item-content-title">
      {{ app.app_name }}
    </div>

    <base-btn-group :state="state"
                    :button-protect="app.supports_protection"
                    button-allow
                    button-block
                    @click="changeAction" />
  </div>
</template>

<script>
  export default {
    props: {
      app: {
        type: Object,
        required: true
      }
    },

    data: () => ({
      state: null
    }),

    created() {
      this.state = this.action
    },

    computed: {
      action() {
        return this.app.app_action
      }
    },

    methods: {
      changeAction(action) {
        this.$emit('changeAction', {
          ...this.app,
          app_action: action
        })
      }
    },

    watch: {
      action() {
        this.state = this.action
      }
    }
  }
</script>